/* GAAH: actual header selectors; labels only in subscription widgets. No commerce-data writes. */
(function(){'use strict';
 if(window.__gaahProductMenuFix)return;window.__gaahProductMenuFix=true;
 var itemSelector='.new-header-nav__item--products';
 function position(item){
  if(window.innerWidth<1060)return;
  var panel=item.querySelector('.new-header-products-menu');if(!panel)return;
  var origin=item.getBoundingClientRect().left;
  var width=panel.getBoundingClientRect().width;
  var viewport=document.documentElement.clientWidth;
  var left=Math.max(16,Math.min(origin,viewport-width-16));
  panel.style.setProperty('--gaah-submenu-shift',(left-origin)+'px');
 }
 function bindMenus(){document.querySelectorAll(itemSelector).forEach(function(item,index){
  if(item.dataset.gaahMenuReady==='true')return;
  var trigger=item.querySelector('.new-header-nav__link--products');
  var panel=item.querySelector('.new-header-products-menu');if(!trigger||!panel)return;
  item.dataset.gaahMenuReady='true';
  if(!panel.id)panel.id='gaah-products-dropdown-'+index;
  trigger.setAttribute('aria-controls',panel.id);trigger.setAttribute('aria-expanded','false');
  function open(){if(window.innerWidth<1060)return;item.classList.remove('gaah-menu-dismissed');item.classList.add('gaah-menu-open');trigger.setAttribute('aria-expanded','true');position(item);}
  function close(dismiss){item.classList.remove('gaah-menu-open');item.classList.toggle('gaah-menu-dismissed',!!dismiss);trigger.setAttribute('aria-expanded','false');}
  item.addEventListener('pointerenter',function(event){if(event.pointerType!=='touch')open();});
  item.addEventListener('pointerleave',function(){if(!item.contains(document.activeElement))close(false);});
  item.addEventListener('focusin',open);
  item.addEventListener('focusout',function(){setTimeout(function(){if(!item.contains(document.activeElement))close(false);},0);});
  var lastPointer='';
  trigger.addEventListener('pointerdown',function(event){lastPointer=event.pointerType;});
  trigger.addEventListener('click',function(event){
   if(window.innerWidth<1060)return;
   if(lastPointer==='touch'||matchMedia('(hover: none)').matches){
    if(trigger.dataset.gaahTouchOpened!=='true'){event.preventDefault();open();trigger.dataset.gaahTouchOpened='true';}
   }
  });
  item.addEventListener('keydown',function(event){
   var links=Array.from(panel.querySelectorAll('a[href]'));
   if(event.key==='Escape'){event.preventDefault();trigger.focus();close(true);trigger.dataset.gaahTouchOpened='false';return;}
   if((event.key==='ArrowDown'||event.key==='ArrowUp')&&links.length){
    event.preventDefault();open();var index=links.indexOf(document.activeElement);
    index=event.key==='ArrowDown'?(index+1)%links.length:(index<=0?links.length-1:index-1);links[index].focus();
   }
   if(event.key===' '&&event.target===trigger){event.preventDefault();if(trigger.getAttribute('aria-expanded')==='true')close(true);else open();}
  });
  document.addEventListener('pointerdown',function(event){if(!item.contains(event.target)){close(true);trigger.dataset.gaahTouchOpened='false';}});
  position(item);
 });}
 function init(){
  bindMenus();document.addEventListener('shopify:section:load',bindMenus);
  var queued=false;
  function refresh(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;document.querySelectorAll(itemSelector).forEach(position);});}
  window.addEventListener('resize',refresh);window.addEventListener('scroll',refresh,{passive:true});
  document.fonts&&document.fonts.ready.then(refresh);
  if(!/^en(?:-|$)/i.test(document.documentElement.lang)||location.pathname.indexOf('/products/')<0)return;
  var labels={'お得定期便':'Subscribe & save','毎月送料無料！':'Free monthly shipping','通常配送':'One-time purchase','1回限り':'Single order','今回だけのご注文':'One-time purchase','定期購入':'Subscription','通常購入':'One-time purchase','お届け周期':'Delivery frequency','数量':'Quantity','続きを読む':'Read more','閉じる':'Close','定期お届けコース':'Subscription delivery','30日ごとにお届け':'Delivery every 30 days','60日ごとにお届け':'Delivery every 60 days','90日ごとにお届け':'Delivery every 90 days','120日ごとにお届け':'Delivery every 120 days'};
  function translateWidgets(){document.querySelectorAll('.huckleberry-subscription-widget-container').forEach(function(root){
   var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),node;
   while((node=walker.nextNode())){var parent=node.parentElement;if(!parent||parent.closest('script,style,textarea,option,input,[contenteditable]'))continue;
    var key=node.nodeValue.trim();if(Object.prototype.hasOwnProperty.call(labels,key))node.nodeValue=node.nodeValue.replace(key,labels[key]);
   }
  });}
  translateWidgets();var timer;
  new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(translateWidgets,60);}).observe(document.body,{childList:true,subtree:true,characterData:true});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
